import React, {Component} from 'react'
import { NavLink } from 'react-router-dom'
import { NavPageStyle } from './../styles'
import { Pan } from './../components'

export default class Nav extends Component {
  state = {
    enable: false,
  }

  render () {
    const { nav } = this.props
    return (
        <div className={`nav-page ${NavPageStyle}`}>
          <Pan>
            <ul className="reset flex content-center flex-nowrap">
              {
                nav.map((item, index) => (
                  <li key={index}>
                    <NavLink to={item.url}> { item.value }</NavLink>
                  </li>
                ))
              }
            </ul>   
          </Pan>     
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav.js